import { token } from '@cp/shared/di';
import { History } from 'history';

export const HISTORY_API = token<History>('HISTORY');
